export const PRECISION = 1e-6;